"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateLocales = exports.TRANSACTION_DATE_FORMAT = exports.CASHFLOW_DATE_FORMAT = exports.WeekTimeFrame = void 0;
var WeekTimeFrame;
(function (WeekTimeFrame) {
    WeekTimeFrame["Past"] = "past";
    WeekTimeFrame["Current"] = "current";
    WeekTimeFrame["Future"] = "future";
})(WeekTimeFrame = exports.WeekTimeFrame || (exports.WeekTimeFrame = {}));
exports.CASHFLOW_DATE_FORMAT = 'YYYY-MM';
exports.TRANSACTION_DATE_FORMAT = 'YYYY-MM-DD';
var DateLocales;
(function (DateLocales) {
    DateLocales["EN_GB"] = "en-gb";
    DateLocales["EN_IL"] = "en-il";
})(DateLocales = exports.DateLocales || (exports.DateLocales = {}));
